'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("documentDrop", function ($document, $rootScope, fileDropUtils) {
  var dragging = false;
  var onDragStart = function onDragStart() {
    dragging = true;
  };
  var onDragStop = function onDragStop() {
    dragging = false;
  };
  fileDropUtils.addFileDragEvents($document, $rootScope, onDragStart, onDragStop);
  return {
    isActive: function isActive() {
      return dragging;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/file-upload/document-drop.js
// module id = 2936
// module chunks = 13